import { createClient } from 'contentful'
import type {
  ChainModifiers,
  Entry,
  EntryFieldTypes,
  EntrySkeletonType,
  LocaleCode,
} from 'contentful'

export const contentfulClient = createClient({
  space: process.env.CONTENTFUL_SPACE_ID ?? '',
  accessToken: process.env.CONTENTFUL_ACCESS_TOKEN ?? '',
})

export interface TypePolicyFields {
  title: EntryFieldTypes.Symbol
  content?: EntryFieldTypes.RichText
  metaTitle?: EntryFieldTypes.Text
  description?: EntryFieldTypes.Text
}

export type TypePolicySkeleton = EntrySkeletonType<TypePolicyFields, 'policy'>
export type TypePolicy<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode = LocaleCode
> = Entry<TypePolicySkeleton, Modifiers, Locales>
